import { autoserializeAs, inheritSerialization } from 'cerialize';
// Don't use a barrel path, otherwise a cyclic dependency issue occurs.
import { ProviderDetail } from '../models/provider-detail';
import { PaginatedResponse } from '@uzurv/core';

@inheritSerialization(PaginatedResponse)
export class PaginatedProviderDetailResponse extends PaginatedResponse {
  @autoserializeAs(ProviderDetail)
  data: Array<ProviderDetail>;
}
